import { Component } from "react";
import { GlobalStateContext } from 'app/contexts/GlobalStateContext';
import ConfiguredCopyJobStatus from "./ConfiguredCopyJobStatus";

class ConfiguredCopyStatus extends Component {
    static contextType = GlobalStateContext;
    constructor(props) {
        super(props);
        this.state = {
            allJobs: [],
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { configuredCopyJobs } = this.context;
        if (configuredCopyJobs?.length > 0) {
            const newJobs = configuredCopyJobs.filter(job => !this.state.allJobs.find(j => j.jobId === job.jobId));
            if (newJobs.length > 0) {
                this.setState({
                    allJobs: [...this.state.allJobs, ...newJobs]
                });
            }
        }
    }

    render() {
        return (
            <div className="job-status">
                {
                    this.state.allJobs.map((job, index) => (
                        <ConfiguredCopyJobStatus key={job.jobId} job={job} />
                    ))
                }
            </div>
        )
    }
}

export default ConfiguredCopyStatus;
